import SpaceAdmin from './SpaceAdmin';

const path = '/dashboard/space-admin';

export const redirects = [
  {
    from: path,
    to: `${path}`,
  },
  {
    from: `${path}/*`,
    to: `${path}`,
  },
];

const routes = [
  {
    name: 'Space Admin',
    path: `${path}`,
    icon: '',
    component: SpaceAdmin,
    exact: true,
  },
];

export default routes;
